<template>
  <transition name="dialogfade">
    <k-dialog v-if="showDialog" :class="['edit-condition-dialog', 'add-condition-dialog', 'add-conditions-dialog', { 'no-conditions': newConditions.length === 0 }]" :title="dialogTitle" @close="closeDialog(false)">
        <div class="select-condition__wrapper">
            <h2 class="section--title">
                Add Conditions <span><i>(required)</i></span>
            </h2>
            <div class="select-condition__dropdown">
                <k-multiselect :data-items="filteredConditionList"
                                :placeholder="'Select Condition'"
                                :text-field="'title'"
                                :data-item-key="'id'"
                                v-model="selectedConditionValues"
                                :filterable="true"
                                @filterchange="onConditionFilterChange"
                                @change="onConditionSelected"></k-multiselect>
            </div>
        </div>
        <div class="condition-detail__container">
            <k-fade :appear="newConditions.length > 0">
                <div class="edit-condition__wrapper">
                    <section class="edit-condition__section-detail">
                    <div class="condition-detail__wrapper">
                        <h2 class="section--title">Condition Detail</h2>
                        <label>
                            Condition
                            <k-dropdown :data-items="newConditions"         
                                            :text-field="'Title'"
                                            :data-item-key="'id'"
                                            v-model="selectedConditionValue"></k-dropdown>
                        </label>
                        <label>
                            Prior To
                            <k-dropdown
                                :data-items="priorToSelects"
                                v-model="selectedConditionValue.priorTo"></k-dropdown>
                        </label>
                        <label>
                            <span class="external__label-row">Condition Description 
                                <k-button v-on:click="populateInternal" :disabled="!selectedConditionValue.externalDescription || selectedConditionValue.externalDescription === selectedConditionValue.internalDescription" class="copy-external__btn">Copy to UW Notes</k-button>
                            </span>
                            <k-textarea @input="checkForConditionChanges" :rows="4" v-model="selectedConditionValue.externalDescription"></k-textarea>
                        </label>
                        <label>
                            <span class="external__label-row">Internal UW Notes
                                <k-button v-on:click="populateExternal" :disabled="!selectedConditionValue.internalDescription || selectedConditionValue.internalDescription === selectedConditionValue.externalDescription" class="copy-external__btn">Copy to Description</k-button>
                            </span>
                            <k-textarea @input="checkForConditionChanges" :rows="4" v-model="selectedConditionValue.internalDescription" ></k-textarea>
                        </label>
                        <label class="print-def-label">Print Definitions</label>
                        <div class="added__info print-def">
                            <k-checkbox class="print-def-checkbox" :checked="selectedConditionValue.conditionPrintDefinitions.find(def => def.type === 'ExternalPrint')?.checked" @change="onPrintDefChange($event, 'ExternalPrint')">
                                <label>Print on Approval Letter/Show in TPO Connect</label>
                            </k-checkbox>
                            <k-checkbox class="print-def-checkbox" :checked="selectedConditionValue.conditionPrintDefinitions.find(def => def.type === 'InternalPrint')?.checked" @change="onPrintDefChange($event, 'InternalPrint')">
                                <label>UW Department Only</label>
                            </k-checkbox>
                        </div>
                    </div>
                    </section>
                    <section class="edit-condition__section-tracking">
                        <h2 class="section--title">Tracking Status</h2>
                        <div v-for="status in selectedConditionValue.trackingStatus" :key="status.status" v-bind:class="['tracking-checkbox__container']">
                            <k-checkbox @change="checkForConditionChanges" v-model="status.isChecked">
                                <label :for="status.status" class="tracking-status__label">{{ status.status }}</label>
                            </k-checkbox>
                        </div>
                    </section>
                </div>
            </k-fade>
        </div>

      <k-dialog-actions>
            <k-button v-bind:class="['dialog__btn dialog__btn--save', { 'dialog__btn--save-active': !saveConditionBtnDisabled }]" v-on:click="saveCondition">{{ saveConditionBtnDisabled ? "Close" : "Save and Close" }}</k-button>
      </k-dialog-actions>

      <transition name="dialogfade">
            <k-dialog v-if="showConfirmCloseDialog" class="edit-condition-dialog confirm-junk-dialog" :title="'You have unsaved changes'" @close="toggleConfirmCloseDialog">
                <p class="confirm-junk--msg">
                    Are you sure you would like to cancel your changes?
                </p>
                <k-dialog-actions>
                    <k-button class="dialog__btn dialog__btn--close" v-on:click="toggleConfirmCloseDialog">No</k-button>
                    <k-button class="dialog__btn dialog__btn--save" v-on:click="confirmCloseDialog">Yes</k-button>
                </k-dialog-actions>
            </k-dialog>
      </transition>

      <div class="conditions__loader-container" v-if="isLoading">
            <loader :size="'large'" :type="'infinite-spinner'"></loader>
      </div>
    </k-dialog>
  </transition>
</template>

<script>
    import auth from "../authConfig.js";
    import apiService from "../api/api.service.js";

    import { Dialog, DialogActionsBar, Window } from "@progress/kendo-vue-dialogs";
    import { Input, TextArea, Checkbox } from "@progress/kendo-vue-inputs";
    import { Button } from "@progress/kendo-vue-buttons";
    import { MultiSelect, DropDownList } from "@progress/kendo-vue-dropdowns";
    import { Loader } from "@progress/kendo-vue-indicators";
    import { filterBy } from "@progress/kendo-data-query";
    import { Fade } from '@progress/kendo-vue-animation';

    import isEqual from "lodash.isequal";
    import cloneDeep from "lodash.clonedeep";

    export default {
    props: ["loanId", "showDialog"],
    emits: ['closenotification', "conditionsadded", "dialogclosed", "requesterror", 'shownotification'],
    data() {
        return {
        conditionList: [],
        conditionsUpdated: false,
        defaultConditionValue: { Title: "Select Condition", id: "0", printDefinitions: [], conditionPrintDefinitions: [{ type: 'ExternalPrint', checked: false }, { type: 'InternalPrint', checked: false }] },
        errorMsg: "",
        errorTitle: "",
        filteredConditionList: [],
        isLoading: false,
        newCondition: {
            ConditionType: "Underwriting",
            Title: "",
            internalDescription: "",
            externalDescription: "",
            priorTo: "",
            id: "",
        },
        newConditionModel: {
            ConditionType: "Underwriting",
            Title: "",
            internalDescription: "",
            externalDescription: "",
            priorTo: "",
            id: "",
        },
        newConditions: [],
        priorToSelects: ["Approval", "Closing", "Docs", "Purchase"],
        saveConditionBtnDisabled: true,
        selectedConditionValue: { Title: 'Select Condition', id: '0', printDefinitions: [], conditionPrintDefinitions: [{ type: 'ExternalPrint', checked: false }, { type: 'InternalPrint', checked: false }] },
        selectedConditionValues: [],
        showConfirmCloseDialog: false,
        trackingStatus: [],
        trackingStatusModel: [
            {
            status: "Requested",
            isChecked: false,
            },
            {
            status: "Re-requested",
            isChecked: false,
            },
            {
            status: "Fulfilled",
            isChecked: false,
            },
            {
            status: "Reviewed",
            isChecked: false,
            },
            {
            status: "Rejected",
            isChecked: false,
            },
            {
            status: "Cleared",
            isChecked: false,
            },
            {
            status: "Waived",
            isChecked: false,
            },
            {
            status: "Removed By Swift",
            isChecked: false,
            },
        ],
        trackingUpdated: false,
        };
    },
    computed: {
        dialogTitle() {
            return "Add Conditions";
        },
    },
    mounted() {},
    watch: {
        showDialog(val) {
            if (val) {
                this.getConditionsToAdd();

                this.newCondition = cloneDeep(this.newConditionModel);
            } else {
                this.conditionsUpdated = false;
                this.trackingUpdated = false;
                this.saveConditionBtnDisabled = true;
                this.isLoading = false;
                this.newConditions = [];
                this.selectedConditionValue = cloneDeep(this.defaultConditionValue);
                this.selectedConditionValues = [];
            }
        },
        "$store.state.errorAlert"(val) {
            if (val) {
                this.isLoading = false;
            }
        },
    },
    methods: {
        async addConditions() {
            let newConditions = this.newConditions.map(cond => {
                return {
                    condition: cond,
                    conditionTracking: cond.trackingStatus
                }
            });

            this.closeDialog(true);
            this.$emit('shownotification');

            let tokenResponse = await auth.acquireTokenResponse();
            this.idTokenClaims = tokenResponse.idTokenClaims;

            apiService.AddConditions(this.loanId, false, newConditions, tokenResponse.accessToken)
                .then(res => {
                    this.$emit("conditionsadded");
                }).catch(error => {
                    this.isLoading = false;
                    this.$emit('closenotification');

                    this.closeDialog(true);

                    this.errorTitle = 'Failed to Add Conditions';

                    if(error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = '';
                    }

                    this.$emit('requesterror', this.errorTitle, this.errorMsg);
                });
        },
        checkForConditionChanges() {
            if (this.newConditions.length > 0) {
                this.conditionsUpdated = true;
            } else {
                this.conditionsUpdated = false;
            }

            this.newConditions.forEach(cond => {
                if (!isEqual(cond.trackingStatus, this.trackingStatusModel)) {
                    cond.trackingUpdated = true;
                } else {
                    cond.trackingUpdated = false;
                }
            })

            if (this.newConditions.length > 0) {
                return (this.saveConditionBtnDisabled = false);
            }

            this.saveConditionBtnDisabled = true;
        },
        closeDialog(force = false) {
            if (!this.saveConditionBtnDisabled && !force) return this.toggleConfirmCloseDialog();

            this.$emit("dialogclosed");
        },
        confirmCloseDialog() {
            this.showConfirmCloseDialog = !this.showConfirmCloseDialog;

            this.$emit("dialogclosed");
        },
        async getConditionsToAdd() {
            this.isLoading = true;

            let tokenResponse = await auth.acquireTokenResponse();
            this.idTokenClaims = tokenResponse.idTokenClaims;

            apiService.GetConditionTemplates(tokenResponse.accessToken)
                .then((res) => {
                    (this.isLoading = false), (this.conditionList = res.data.data);

                    this.filteredConditionList = JSON.parse(JSON.stringify(this.conditionList));
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.closeDialog();

                    this.errorTitle = "Failed to Fetch Conditions";

                    if (error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = "";
                    }

                    this.$emit("requesterror", this.errorTitle, this.errorMsg);
                });
        },
        onConditionFilterChange(evt) {
            this.filteredConditionList = filterBy(this.conditionList, evt.filter);
        },
        onConditionSelected(evt) {
            this.selectedConditionValues.forEach(cond => {
                if (!this.newConditions.some(c => c.id === cond.id)) {
                    this.newConditions.push({
                        ConditionType: 'Underwriting',
                        id: cond.id,
                        priorTo: cond.priorTo,
                        Title: cond.title,
                        internalDescription: cond.internalDescription ? cond.internalDescription : '',
                        externalDescription: cond.externalDescription ? cond.externalDescription : '',
                        trackingStatus: cloneDeep(this.trackingStatusModel),
                        printDefinitions: cloneDeep(cond.printDefinitions),
                        conditionPrintDefinitions: [
                            { type: 'InternalPrint', checked: cond.printDefinitions.some(def => def === 'InternalPrint' )},
                            { type: 'ExternalPrint', checked: cond.printDefinitions.some(def => def === 'ExternalPrint' )}
                        ],
                        trackingStatusUpdated: false
                    });
                }
            });

            this.newConditions.forEach((cond, index) => {
                let foundIndex = this.selectedConditionValues.findIndex(c => c.id === cond.id);

                if (foundIndex < 0) {
                    this.newConditions.splice(index, 1);
                }
            });

            if (this.newConditions.length > 0) {
                this.selectedConditionValue = this.newConditions[this.newConditions.length - 1];
            } else {
                this.selectedConditionValue = cloneDeep(this.defaultConditionValue);
            }

            this.checkForConditionChanges();
        },
        onPrintDefChange(evt, defType) {
            if (this.selectedConditionValue) {
                let definition = this.selectedConditionValue.conditionPrintDefinitions.find(def => def.type === defType);

                if (definition) {
                    definition.checked = evt.value;
                    let definitions = this.selectedConditionValue.conditionPrintDefinitions.filter(def => def.checked).map(def => def.type);

                    this.selectedConditionValue.printDefinitions = definitions.sort();
                }
            }
        },
        populateExternal() {
            this.selectedConditionValue.externalDescription = this.selectedConditionValue.internalDescription;
            this.checkForConditionChanges();
        },
        populateInternal() {
            this.selectedConditionValue.internalDescription = this.selectedConditionValue.externalDescription;
            this.checkForConditionChanges();
        },
        async saveCondition() {
            if (this.saveConditionBtnDisabled) return this.closeDialog();

            if (this.conditionsUpdated) {
                return await this.addConditions();
            }
        },
        toggleConfirmCloseDialog() {
            this.showConfirmCloseDialog = !this.showConfirmCloseDialog;
        }
    },
    components: {
        "k-dialog": Dialog,
        "k-dialog-actions": DialogActionsBar,
        "k-textarea": TextArea,
        "k-button": Button,
        "k-dropdown": DropDownList,
        "k-checkbox": Checkbox,
        loader: Loader,
        "k-multiselect": MultiSelect,
        'k-fade': Fade
    },
    };
</script>

<style>
    @import "/src/assets/css/editConditionDialog.css";
    @import "/src/assets/css/addConditionDialog.css";
    @import "/src/assets/css/addConditionsDialog.css";
</style>
